import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBell: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bell, notification, activity, alert"><path d="M12 2C7.79218 2 4.19826 5.17264 3.74999 9.35647L3.08474 13.0926C2.67558 15.3906 4.44259 17.5 6.77668 17.5H17.2234C19.5575 17.5 21.3245 15.3905 20.9153 13.0925L20.25 9.35648C19.8017 5.17264 16.2077 2 12 2Z" fill="currentColor"/><path d="M16.5839 19H7.416C8.18756 20.7659 9.94964 22 12 22C14.0503 22 15.8124 20.7659 16.5839 19Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBell;
